import styled, { css } from 'styled-components'

export const InfoBarStyled = styled.div`
    width: 100%;
    text-transform: uppercase;
`

export const InfoBarOffline = styled.div`
    background: ${({ theme }) => theme.pastelRed50};
    color: ${({ theme }) => theme.white};
    padding: 10px;
    border-radius: 4px;
    text-align: center;
    margin: 10px 0;
`

export const InfoBarContent = styled.div`
    background-color: ${({ theme }) => theme.grassyGreen};
    color: ${({ theme }) => theme.white};
    padding: 10px;
    border-radius: 4px;
    text-align: center;
    margin: 10px 0;
    font-size: 14px;
    font-weight: ${( { theme }) => theme.fontWeight.bold};
    ${({ isInvalid }) =>
        isInvalid &&
        css`
          background-color: ${({ theme }) => theme.lightPeach};
          color: ${({ theme }) => theme.whiteTwo};
          font-weight: ${( { theme }) => theme.fontWeight.bold};
        `
    };
`